export const slideLength = 5000;

export const imageLocation = "https://cobbarch-data.s3-us-west-2.amazonaws.com/images/"


// WEBPACK FOOTER //
// ./src/config/constants.js